
<div class="modal">

  <!-- Header -->
  <div class="modal-header" style="display: none;">
    <div class="header-left">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
          <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
        </svg>
      </div>
      <div class="header-text">
        <h2>Add Component</h2>
        <p>Associate a new component to this truck</p>
      </div>
    </div>
    <button class="close-btn">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <!-- Truck Banner -->
  <div class="truck-banner">
    <div class="truck-left">
      <div class="truck-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
      </div>
      <div>
        <div class="truck-id">{{truckDetails?.truckNumber}}</div>
        <div class="truck-sub">{{truckDetails?.truckModel}} </div>
      </div>
    </div>
    <div class="truck-right">
      <div class="km-badge"><span>Current KM: </span>{{truckDetails?.initialKmTravelled}}</div>
      <!-- <div class="live-badge"><div class="live-dot"></div> 5 Live</div> -->
    </div>
  </div>

  <div class="modal-body">

    <!-- Step 1 -->
    <div class="step-label">Component Type &amp; Serial</div>
    <div class="form-row">
      <div class="form-group">
        <label><span class="req">*</span> Component Type</label>
        <div class="select-wrap">
            <ng-select (change)="onTypeChange($event)" appendTo="body"  placeholder="Select " class="field-input filled">
                <ng-option value="Tyre">Tyre</ng-option>
                <ng-option value="Battery">Battery</ng-option>
                <ng-option value="PUC">PUC</ng-option>
                <ng-option value="Insurance">Insurance</ng-option>
                <!-- <ng-option value="Dealer">Dealer </ng-option> -->
            </ng-select>
        </div>
        <!-- <span class="form-hint">Tyre, Battery, Insurance, PUC Etc.</span> -->
      </div>
      <div class="form-group" *ngIf="componentType == 'Tyre'">
        <label><span class="req">*</span> Association Type</label>
        <div class="select-wrap">
            <ng-select (change)="onChangecomponentType($event)" appendTo="body"  placeholder="Select " class="field-input filled">
                <ng-option value="TRUCK">Truck</ng-option>
                <ng-option value="TRAILER">Trailer</ng-option>
            </ng-select>
        </div>
      </div>
      <div class="form-group">
        <ng-container *ngIf="componentType == 'Tyre' || componentType == 'Battery'">
          <label><span class="req">*</span> Serial Number</label>
        <ng-select appendTo="body" (change)="onserialChange($event)" [(ngModel)]="serialNumber"  placeholder="Select " class="field-input filled">
            <ng-option *ngFor="let item of componantList" [value]="item.id">{{item.serialNumber}}</ng-option>
        </ng-select>
        </ng-container>
        <ng-container *ngIf="componentType == 'PUC'">
          <label><span class="req">*</span> PUC Via</label>
          <ng-select appendTo="body" (change)="onserialChange($event)" [(ngModel)]="serialNumber"  placeholder="Select " class="field-input filled">
              <ng-option *ngFor="let item of componantList" [value]="item.id">{{item.name}}</ng-option>
          </ng-select>
        </ng-container>
        <ng-container *ngIf="componentType == 'Insurance'">
          <label><span class="req">*</span> Insurer Name</label>
          <ng-select appendTo="body" (change)="onserialChange($event)" [(ngModel)]="serialNumber"  placeholder="Select " class="field-input filled">
              <ng-option *ngFor="let item of componantList" [value]="item.id">{{item.name}}</ng-option>
          </ng-select>
        </ng-container>
        <ng-container *ngIf="componentType == 'Dealer'">
          <label><span class="req">*</span> Dealer Code</label>
          <ng-select appendTo="body" (change)="onserialChange($event)" [(ngModel)]="serialNumber"  placeholder="Select " class="field-input filled">
              <ng-option *ngFor="let item of componantList" [value]="item.id">{{item.vendorCode}}</ng-option>
          </ng-select>
        </ng-container>
      </div>
    </div>

    <!-- Step 2 -->
    <ng-container *ngIf="componentType == 'Tyre' || componentType == 'Battery'">
      <div class="step-label">Auto-Populated Info</div>
      <div class="form-row">
        <div class="form-group">
          <label>Brand</label>
          <input type="text" [value]="selectedComponent?.brandName" readonly>
        </div>
        <div class="form-group">
          <label>Model</label>
          <input type="text" [value]="selectedComponent?.productCode" readonly>
        </div>
        <div class="form-group">
          <label>Mfg. Date</label>
          <input type="text" [value]="selectedComponent?.mfgDate  | CustomDatePipe: 'D-M-YYYY'" readonly>
        </div>
      </div>
    </ng-container>

    <!-- Brand & Model (auto-populated) -->
     <div class="form-row compliance-details" *ngIf="componentType == 'PUC' || componentType == 'Insurance' || componentType == 'Dealer '">
      <div class="form-grid grid-2">

      <div class="form-group">
          <label class="field-label">
            {{componentType == 'PUC' ? 'PUC ID' : 
            componentType == 'Insurance' ? 'Insurance Number' : 
            componentType == 'Dealer' ? 'Dealer Name' : ''}}
             <span class="required-dot">*</span></label>
          <div class="field-input">
              <input type="text" trim="blur" class="input" [(ngModel)]="pollutionNumber"  />
          </div>
      </div>

      <div class="form-group">
          <label class="field-label">Valid From <span class="required-dot">*</span></label>
          <div class="field-input">
                        <p-calendar appendTo="body" class="mfgDate" name="date" [(ngModel)]="pollutionValidityFrom" view="date" dateFormat="dd/mm/yy" (onSelect)="onDateSelect($event)"></p-calendar>

          </div>
      </div>
      <div class="form-group">
          <label class="field-label">Valid Till <span class="required-dot">*</span></label>
          <div class="field-input">
            <p-calendar appendTo="body" class="mfgDate"  dateFormat="dd/mm/yy"  [(ngModel)]="pollutionValidityTill" [minDate]="pollutionValidityFrom"  [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2035"></p-calendar>
          </div>
      </div>
      <div class="form-group">
           <div class="field">
            <label class="field-label">Upload PUC (PDF, JPG, PNG)</label>
            <div class="file-upload">
              <!-- <div class="file-icon">📄</div> -->
              <div class="file-text">
                <input type="file" id="uploads" name="uploads" (change)="selectFile($event,'Pollution')" accept=".pdf, .jpg, .jpeg, .png, .svg" #uploadPollutionInput>
              </div>
              <div class="uploadFile" *ngIf="pollutionUploadUrl != null && pollutionUploadUrl != ''">
                <span class="file-icon">
                  <svg fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="icon">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path d="M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"></path>
                        </g>
                      </svg>
                  </span>
                <a class="clossfile" (click)="removeFile('Pollution')"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-dialog-header-close-icon p-icon" aria-hidden="true"><path d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z" fill="currentColor"></path></svg></a>
              </div>
            </div> 
          </div>
      </div>
      </div>
      </div>
    <!-- Step 3 -->
    <div class="step-label">Association Details</div>
    <div class="form-row">
      <div class="form-group">
        <label><span class="req">*</span> From Date</label>
        <div class="input-wrap">
          <p-calendar appendTo="body" class="mfgDate" name="date" [(ngModel)]="associationDate" view="date" dateFormat="dd/mm/yy" [maxDate]="maxDate" (onSelect)="onDateSelect($event)"></p-calendar>

          <!-- <input type="text" placeholder="DD / MM / YYYY" [value]="selectedComponent?.purchaseDate"> -->
          <span class="input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
          </span>
        </div>
        <span class="form-hint">Date component is fitted to truck</span>
      </div>
      <div class="form-group">
        <label>KM at Association </label>
        <div class="km-wrap">
          <input class="form-input" id="kmAtRemoval" type="text" [(ngModel)]="associationkm" placeholder="e.g. 2032" oninput="updateSummary()" (keypress)="sharedService.isNumberOnly($event)"/>
          <span class="km-unit">km</span>
        </div>
        <span class="form-hint">Current odometer reading</span>
      </div>

      <!-- <div class="form-group">
        <label><span class="req">*</span> Association Status</label>
        <div class="select-wrap">
            <ng-select appendTo="body" [(ngModel)]="associationStatus"  placeholder="Select " class="field-input filled">
                <ng-option value="NEW">New</ng-option>
                <ng-option value="SPARE">Spare</ng-option>
                <ng-option value="IN-USE">In Use</ng-option>
            </ng-select>
        </div>
      </div> -->
    </div>

    <!-- Summary -->
    <div class="summary">
      <div class="summary-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
        </svg>
        Summary
      </div>
      <div class="summary-rows">
        <div class="summary-row">
          <span class="key">Truck</span>
          <span class="val">{{truckDetails?.truckNumber}}</span>
        </div>
        <div class="summary-row">
          <span class="key">Component</span>
          <span class="val">
            <div class="component-tag">
              <div class="component-dot"></div> {{selectedComponent?.componentType || componentType}} · {{selectedComponent?.serialNumber || selectedComponent?.name}}
            </div>
          </span>
        </div>
        <div class="summary-row">
          <span class="key">From Date</span>
          <span class="val dash">{{associationDate  | CustomDatePipe: 'D-M-YYYY'}} </span>
        </div>
        <div class="summary-row">
          <span class="key">KM at Association</span>
          <span class="val dash">{{associationkm}} km</span>
        </div>
        <!-- <div class="summary-row">
          <span class="key">Running Status</span>
          <span class="val live-val"><div class="live-dot"></div> {{selectedComponent?.status}}</span>
        </div> -->
      </div>
    </div>

  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <!-- <span class="footer-note">Running Status will be set to Live automatically</span> -->
    <div class="footer-actions">
      <button class="btn btn-cancel" (click)="close()">Cancel</button>
      <button class="btn btn-primary" (click)="addComponent()" >
        <!-- <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg> -->
        Add Component
      </button>
    </div>
  </div>

</div>